export default __webpack_public_path__ + "8b8b909e42722172d494835d17e0a2b6.svg";